/*
 * @Author       : lenchen
 * @Date         : 2020-06-23 11:29:03
 * @LastEditors  : lenchen
 * @LastEditTime : 2021-02-02 14:11:10
 * @FilePath     : \ihub\src\utils\request.js
 * @Description  :
 */
import axios from "axios";
import { Message } from "element-ui";
import md5 from "blueimp-md5";
import { getToken } from "@/utils/auth";
import store from "@/store";
import router from "@/router";
import siteConfig from "@/config";
import ab2str from "arraybuffer-to-string";
import {handleBusinessError} from "@/utils/errorHandler";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: siteConfig.API.AXIOS_TIMEOUT,
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    const ts = Math.round(new Date().getTime() / 1000);
    const sign = md5(`${ts}BOiZe8yxyseVIHif`);
    if (!config.data) {
      config.data = {};
    }
    config.headers.sign = sign;
    config.headers.timestamp = ts;
    config.headers.ticket = getToken();
    const aegisId = localStorage.getItem('AEGIS_ID'); // 官网新增设备ID记录 需求
    if (aegisId && config.url?.includes('community/custom.php')) {
      config.headers['Aegis-Id'] = aegisId;
    }
    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  async (response) => {
    if (
      response.config.url.indexOf("/upload.php?c=download&a=downloadFile") > -1
    ) {
      if (response.headers["content-type"] === "application/octet-stream") {
        return response;
      }
      const resStr = ab2str(response.data);
      return Promise.reject(JSON.parse(resStr));
    }

    const res = response.data;
    if (siteConfig.API.ERROR_CODE.includes(res.ret)) {
      await store.dispatch("user/logout");
      // router.push(`/home?login=1&redirect=${router.currentRoute.fullPath}`);
    }

    handleErrorCode(res);
    if([-103,-115].includes(res?.code)){ // -115 违规词 -103 禁言
       if(handleBusinessError(res.code,res)){
        return res;
       }
    }
    if (
      siteConfig.API.SUCCESS_CODE.includes(res.ret || res.code) ||
      siteConfig.API.NO_MODIFY_AUTH_CODE.includes(res.ret)
    ) {
      return res;
    }

    return res;
  },
  async (error) => {
    console.log('error',error);
    if(error.name !== 'CanceledError'){ // 忽略取消请求
     Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000,
      offset: 50,
    });
    }
  
    return Promise.reject(error);
  }
);

const handleErrorCode = async (res)=>{
  if ([-102,-116,-117,-118].includes(res?.code)) { // -102封号 -116 账号异常，冻结或删除或其它-117 未完成邀请操作-118 未签署保密协议
    if(res?.code === -102 && window.location.hash.includes('oauth')) return; // 登录页不需要
    Message({
      message: res.message,
      type: "error",
      duration: 5 * 1000,
      offset: 50,
    });
    await store.dispatch("user/logout");
    store.state.user.token = getToken();
    store.state.app.render = !store.state.app.render;
    if([-116,-117,-118].includes(res?.code)){
      window.location.href = `/#/oauth?app_id=5012568a421eeb0b&redirect_url=${location.origin}/#${router.currentRoute.fullPath}`
    }
  }
}


export async function fetchSSE(url, { onopen, onmessage, onclose, onerr, ...option }) {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Ticket': getToken(),
      },
      ...option,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    onopen(response)
    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
  
    while (true) {
      const { done, value } = await reader.read();
  
      if (done) {
        break;
      }
  
      const chunk = decoder.decode(value, { stream: true });
      // const event = parseSSE(chunk);
      // console.log(event, chunk);
      
      if (chunk) {
        // console.log('Received chunk:', chunk);
        onmessage(chunk.startsWith('"response":') ? chunk.slice(11) : chunk);
        // 处理事件
      }
    }
    onclose()
   } catch (error) {
    onerr(error)
    // this.$message.error(error);
  }
}

export async function fetchSSE_EA(url, { onopen, onmessage, onclose, onerr, ...option }) {
  try {
    const ts = Math.round(new Date().getTime() / 1000);
    const sign = md5(`${ts}BOiZe8yxyseVIHif`);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Ticket': getToken(),
        sign: sign,
        timestamp: ts,
        appid: 'wxupadmin'
      },
      ...option,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    onopen(response)
    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
  
    while (true) {
      const { done, value } = await reader.read();
  
      if (done) {
        break;
      }
  
      const chunk = decoder.decode(value, { stream: true });
      // const event = parseSSE(chunk);
      // console.log(event, chunk);
      
      if (chunk) {
        // console.log('Received chunk:', chunk);
        onmessage(chunk.startsWith('"response":') ? chunk.slice(11) : chunk);
        // 处理事件
      }
    }
    onclose()
   } catch (error) {
    onerr(error)
    // this.$message.error(error);
  }
}

export async function fetchSSE_EA_WithAbort(url, { onopen, onmessage, onclose, onerr, stopControl, ...option }) {
  const ts = Math.round(new Date().getTime() / 1000);
  const sign = md5(`${ts}BOiZe8yxyseVIHif`);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Ticket': getToken(),
        sign: sign,
        timestamp: ts,
        appid: 'wxupadmin'
      },
      ...option,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    try {
      onopen(response)
    } catch (callbackError) {
      console.error('onopen 回调错误:', callbackError);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');

    try {
      while (true) {
        // 检查是否需要停止
        if (stopControl && stopControl.stopped) {
          break;
        }

        const { done, value } = await reader.read();

        if (done) {
          break;
        }

        const chunk = decoder.decode(value, { stream: true });

        if (chunk) {
          try {
            // 在调用 onmessage 之前再次检查
            if (!stopControl || !stopControl.stopped) {
              onmessage(chunk.startsWith('"response":') ? chunk.slice(11) : chunk);
            }
          } catch (messageError) {
            console.error('onmessage 回调错误:', messageError);
          }
        }
      }
    } catch (readError) {
      throw readError;
    }

    try {
      onclose()
    } catch (callbackError) {
      console.error('onclose 回调错误:', callbackError);
    }
  } catch (error) {
    // 检查是否为中止错误
    const isAbortError =
      error.name === 'AbortError' ||
      (error.message && error.message.includes('aborted')) ||
      error.message === 'The user aborted a request.';

    if (!isAbortError && onerr) {
      onerr(error);
    }
  }
}

export const fetchPost = ({url, data}) => {
  const ts = Math.round(new Date().getTime() / 1000);
  const sign = md5(`${ts}BOiZe8yxyseVIHif`);
  const fecthParam = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Ticket: getToken(),
      sign: sign,
      timestamp: ts,
    },
    mode: 'cors',
    // credentials: 'include', // 强制携带 Cookie
    body: JSON.stringify(data),
  }
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ticket: getToken(),
      sign: sign,
      timestamp: ts,
    },
    mode: 'cors',
    // credentials: 'include', // 强制携带 Cookie
    body: JSON.stringify(data),
  }).then((response) => {
    return response.json();
  })
}

export default service;
